<template>
    <div class="order-card-wrapper">
        <van-pull-refresh v-model="refreshLoading" @refresh="()=>{this.getList(1)}">
            <!-- 列表 -->
            <van-list
                v-if="orderList.length > 0"
                v-model="loading"
                :error-text="'请求失败， 点击重新加载'"
                :error.sync="error"
                :finished="finished"
                @load="getList"
                finished-text="没有更多了">
                <!-- 卡片 -->
                <div v-for="(card, index) in orderList" :key="index" class="card" @click="goDetail(card)">
                    <section class="top">
                        <div class="title-info">
                            <p>下单日期：{{ card.orderTime }}</p>
                            <p>订单编号：{{ card.orderNo }}</p>
                        </div>
                        <div v-if="![6,12].includes(card.orderType)" :class="className(card.orderStatus)">{{card.orderStatusName }}</div>
                        <div v-else :class="className(card.orderStatus)">{{ card.orderStatusName }}</div>
                    </section>

                    <div v-if="card.orderType === 6" class="teacher-info">
                        <p :class="[card.accompanyDto.coachName && 'exist']">陪驾教练：<b>{{ card.accompanyDto.coachName || '—' }}</b></p>
                        <p :class="[card.accompanyDto.coachName && 'exist']" @click.stop="call(card.accompanyDto.coachMobile)">联系电话：<b>{{card.accompanyDto.coachMobile || '—' }}</b></p>
                    </div>

                    <section
                        :class="['middle',(card.orderStatus !== 1 && card.orderStatus !== 2) && 'border-none' ]">
                        <div class="goods-info">
                            <div class="img-wrapper">
                                <img v-if="['100'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_kyvipkcslt.png">
                                <img v-else-if="['101'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_kejxspslt.png">
                                <img v-else-if="['103'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_kekcjjslt.png">
                                <img v-else-if="['104'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ksjxspslt.png">
                                <img v-else-if="['105'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_kskcspslt.png">
                                <img v-else-if="['106'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ksdgmnslt.png">
                                <img v-else-if="['107'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ksvipslt.png">
                                <img v-else-if="['201','202','203','204'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_qkvipslt.png">
                                <img v-else-if="['205','206'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_kezxvipslt.png">
                                <img v-else-if="['200'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ky+ksvipslt.png">
                                <img v-else-if="['207','208','209','210'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ke+ksvipslt.png">
                                <img v-else-if="['211','212','213','214'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ke+ks+ksvipslt.png">
                                <img v-else-if="['215','216','217','218'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_kszxvipslt.png">
                                <img v-else-if="['219','220','221','222'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ks+ksvipslt.png">
                                <img v-else-if="['223'].includes(card.goodsCode)" alt="" class="img" src="@/assets/vipGoods/order/icon_ks+ksjhkslt.png">
                                <img v-else-if="card.orderType === 1" alt="" class="img" src="@/assets/vip/icon_vipthumbnail@2x.png">
                                <img v-else-if="card.orderType === 8" alt="" class="img" src="@/assets/vip/icon_viptcx.png">
                                <img v-else-if="card.orderType === 9" alt="" class="img" src="@/assets/goods/icon_kmsdgfzvip.png">
                                <img v-else-if="card.orderType === 7" alt="" class="img" src="@/assets/vip/icon_gkbz.png">
                                <img v-else-if="card.orderType === 2 || card.orderType === 6 || card.orderType === 13" :src="card.iconUrl" class="img"/>
                                <img v-else-if="card.orderType === 4" alt="" class="img" src="@/assets/videoVip/icon_teachvideo.png">
                                <img v-else-if="card.orderType === 5 && card.vipDto.subject === 2" alt="" class="img" src="@/assets/videoVip/icon_s2examinationvideo.png">
                                <img v-else-if="card.orderType === 5 && card.vipDto.subject === 3" alt="" class="img" src="@/assets/videoVip/icon_s3examinationvideo.png">
                                <img v-else-if="card.orderType === 10" alt="" class="img" src="@/assets/microCourse/order.png">
                                <img v-else-if="card.orderType === 11" alt="" class="img" src="@/assets/simulation/mnj.png">
                                <img v-else-if="card.orderType === 12" alt="" class="img" src="@/assets/timeAppPay/icon_kyksjsk.png">
                                <img v-else-if="card.orderType === 15" alt="" class="img" src="@/assets/studyDrive/icon_lcks.png">
                                <img v-else-if="card.orderType === 16" alt="" class="img" src="@/assets/studyDrive/icon_yecz.png">
                            </div>
                            <div class="right-box">
                                <div class="goods-name">{{ card.orderTitle }}</div>
                                <div v-if="card.orderSubTitle" class="goods-exam-place-name">
                                    {{ card.orderSubTitle }}
                                </div>
                                <div v-if="card.orderType === 6" class="other-name">
                                    {{ card.accompanyDto.orderItemTipsName }}
                                </div>
                                <div v-if="card.orderType === 6" class="price">
                                    <div>¥{{ card.accompanyDto.orderItemTipsPrice }}/{{ card.accompanyDto.orderItemTipsHours }}小时</div>
                                    <div>x{{ card.orderNumber }}</div>
                                </div>
                                <div v-else class="price">
                                    <div>{{ card.orderPrice }}</div>
                                    <div>x{{ card.orderNumber }}</div>
                                </div>
                                <div class="remark" v-if="card.accompanyDto && card.accompanyDto.remark">
                                    <div>{{ card.accompanyDto && card.accompanyDto.remark }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="summation">
                            <span>合计：</span>
                            <template v-if="card.pointMallDto">
                                <span v-if="card.pointMallDto.unitRmbAmount">¥{{ card.pointMallDto.unitRmbAmount }}</span>
                                <span v-if="card.pointMallDto.unitRmbAmount && card.pointMallDto.unitBeanAmount">+</span>
                                <span v-if="card.pointMallDto.unitBeanAmount">{{ card.pointMallDto.unitBeanAmount }}斑豆</span>
                                <span v-if="!card.pointMallDto.unitRmbAmount && !card.pointMallDto.unitBeanAmount">¥0</span>
                                <span v-if="card.pointMallDto.expressPrice">{{ `(含快递费￥${card.pointMallDto.expressPrice})` }}</span>
                            </template>
                            <template v-else>
                                <span>{{ card.orderPrice }}</span>
                            </template>

                        </div>
                    </section>
                    <!-- 待付款和待发货才显示footer -->
                    <section v-if="
                        card.orderType === 11 || 
                        card.buttonDto.showPayBtn || 
                        card.buttonDto.showCancelBtn || 
                        card.buttonDto.showRefundBtn || 
                        card.buttonDto.showEvaluateBtn || 
                        card.buttonDto.showViewEvaluateBtn || 
                        card.buttonDto.showViewCarHailBtn || 
                        card.buttonDto.showRevokeRefundBtn || 
                        card.buttonDto.showActiveBtn || 
                        (card.pointMallDto && card.pointMallDto.expressCompanyCode)
                    "
                             class="footer">
                        <van-button :loading='payLoading' v-show="card.buttonDto.showPayBtn || card.buttonDto.showActiveBtn" class="button" type="default"
                                    @click.stop="pay(card)">{{
                                (Number(card.paymentType) === 4 || Number(card.paymentType) === 5)
                                    ? '立即激活' : '立即支付'
                            }}
                        </van-button>
                        <van-button v-show="card.orderType === 11" class="button" type="default"
                                    @click.stop="call(card.zzSimulationDto.servicePhone)">客服电话
                        </van-button>
                        <van-button v-show="card.buttonDto.showCancelBtn" class="button" type="default"
                                    @click.stop="cancel(card)">取消订单
                        </van-button>
                        <van-button v-show="card.buttonDto.showRefundBtn" class="button" type="default"
                                    @click.stop="refund(card)">申请退款
                        </van-button>
                        <van-button v-show="card.buttonDto.showRevokeRefundBtn" class="button" type="default"
                                    @click.stop="resetRefund(card)">撤销退款
                        </van-button>
                        <van-button v-show="card.buttonDto.showEvaluateBtn" class="button" type="default"
                                    @click.stop="evaluate(card)">
                            {{ card.evaluateFlag ? '已评价' : '评价' }}
                        </van-button>
                        <van-button v-show="card.pointMallDto && card.pointMallDto.expressCompanyCode" class="button" type="default"
                                    @click.stop="express(card)">
                            查看物流
                        </van-button>
                        <van-button v-show="card.buttonDto.showViewEvaluateBtn" class="button" type="default"
                                    @click.stop="evaluate(card)">查看评价
                        </van-button>
                        <van-button v-show="card.buttonDto.showViewCarHailBtn" class="button" type="default"
                                    @click.stop="handleToStudyDriveHistory(card)">查看约车
                        </van-button>
                    </section>
                </div>
            </van-list>
            <div v-else class="none-order">
                <img alt="" src="@/assets/order/picture_noorder.png">
                <p>暂无订单</p>
                <p>快去看看有什么想买的</p>
            </div>
        </van-pull-refresh>
        <ctl-dialog v-model="dialogData" :loading="loading"/>
        <ctl-dialog v-model="codeDialogData" :dialogStyle="dialogStyle" :loading="loading">
            <div slot="content" class="password-input">
                <ul @click="clickInput">
                    <li v-for="v in 6" :key="v">{{ codeValue[v - 1] }}</li>
                </ul>
                <input ref="input" v-model="codeValue" maxlength="6" type="text"/>
            </div>
        </ctl-dialog>
    </div>
</template>

<script>
import { List, Tab, Tabs, Button, PullRefresh, Toast } from 'vant'
import dialog from '@/components/dialog/index'
import mixinStudyDrive from './mixinStudyDrive.js'
export default {
    name: 'orderCard',
    mixins: [mixinStudyDrive],
    components: {
        [List.name]: List,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Button.name]: Button,
        [Toast.name]: Toast,
        ctlDialog: dialog,
        [PullRefresh.name]: PullRefresh
    },
    props: [
        'active'
    ],
    watch: {
        active: {
            handler () {
                this.getList(1)
            },
            deep: true
        }
    },
    data () {
        return {
            codeValue: '',
            refreshLoading: false,
            loading: false,
            error: false,
            finished: false,
            // 苹果标记
            IOS: !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            orderList: [],
            payLoading: false,
            dialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            },
            pageData: {
                current: 1,
                size: 6
            },
            dialogStyle: { marginBottom: '' },
            codeDialogData: {
                visible: false,
                rightBtnName: '',
                leftBtnName: '',
                leftBtnMethod: '',
                rightBtnMethod: '',
                title: '',
                content: ''
            }
        }
    },
    created () {

    },
    methods: {
        // 获取类型名称
        className (v) {
            const data = {
                1: 'payment',
                2: 'beshipped',
                3: 'shipped',
                4: 'completed',
                5: 'cancelled',
                6: 'refund',
                7: 'refund',
                8: 'completed'
            }
            if (data[v]) {
                return `${data[v]} status`
            } else {
                return 'refund status'
            }
        },
        // 退款
        refund (v) {
            if (v.orderType === 6) {
                this.$router.push({ name: 'refundPeijia', query: { id: v.id } })
                return
            }
            if (v.orderType === 15) { // 港安排班约车 申请退款
                this.cancelBookingOrder(v.id).then(() => {
                    this.getList(1)
                })
                return
            }
            if (v.orderType === 16) { // 港安排班余额 申请退款
                this.applyPayRefund(v.id).then(() => {
                    this.getList(1)
                })
                return
            }
            this.dialogData = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.dialogData.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.dialogData.visible = false
                    this.$api.orderRefundApply({ orderId: v.id }).then(res => {
                        if (res.status) {
                            this.getList(1)
                        }
                        this.loading = false
                    })
                },
                title: '提示',
                content: '确定发起退款吗？'
            }
        },
        // 评价
        evaluate (v) {
            let data = {
                ids: [v.id],
                terminalType: 1
            }
            // 港安排班评价
            if ([15].includes(v.orderType)) {
                location.href = `/ui/common-h5/bbjd-app/reservation-study-drive/v1/history/trainComment?orderId=${v.id}&hideNav=1`;
                return;
            }
            if (v.evaluateFlag) {
                this.$router.push({
                    name: 'evaluatePeijia',
                    query: { id: v.id, coachName: v.accompanyDto.coachName, coachMobile: v.accompanyDto.coachMobile }
                })
                return
            }
            if (v.orderStatusName === '已分配' || v.orderStatusName === '退款失败') {
                this.dialogData = {
                    visible: true,
                    rightBtnName: '已完成',
                    leftBtnName: '未完成',
                    leftBtnMethod: () => {
                        this.dialogData.visible = false
                    },
                    rightBtnMethod: () => {
                        this.$api.finishPeijia(data).then(res => {
                            if (res.status) {
                                this.$router.push({
                                    name: 'evaluatePeijia',
                                    query: { id: v.id, coachName: v.accompanyDto.coachName, coachMobile: v.accompanyDto.coachMobile }
                                })
                            }
                        })
                    },
                    title: '提示',
                    content: '您的陪驾服务是否已全部完成？'
                }
            } else if (v.orderStatusName === '已完成') {
                this.$router.push({
                    name: 'evaluatePeijia',
                    query: { id: v.id, coachName: v.accompanyDto.coachName, coachMobile: v.accompanyDto.coachMobile }
                })
            } else {
                this.dialogData = {
                    visible: true,
                    rightBtnName: '已完成',
                    leftBtnName: '未完成',
                    leftBtnMethod: () => {
                        this.dialogData.visible = false
                    },
                    rightBtnMethod: () => {
                        this.$router.push({
                            name: 'evaluatePeijia',
                            query: { id: v.id, coachName: v.accompanyDto.coachName, coachMobile: v.accompanyDto.coachMobile }
                        })
                    },
                    title: '提示',
                    content: '您的陪驾服务是否已全部完成？'
                }
            }
        },
        // 快递
        express (v) {
            localStorage.setItem('tempToken', localStorage.getItem('ctl-token'))

            let newUrl = `https://m.kuaidi100.com/app/query/?com=${v.pointMallDto.expressCompanyCode}&nu=${v.pointMallDto.expressNo}&coname=banbanjiadao`

            // 通知app跳转
            this.$jsBridge.callBackHandler('openCurrenrUrl', {
                curUrl: location.href.replace('http://', ''),
                newUrl: 'm.kuaidi100.com'
            })

            document.title = '物流信息'

            // 改变app title
            this.$jsBridge.callBackHandler('changeTitle', { title: '物流信息' })

            location.href = newUrl
        },
        // 取消订单
        cancel (v) {
            let cancelOrder = this.$api.cancelOrder
            if (v.orderType === 8) {
                cancelOrder = this.$api.cancelVipPackageOrder
            } else if (v.orderType === 9) {
                // 灯光仿真商品 取消订单接口
                cancelOrder = this.$api.lightCancelOrder
            } else if (v.orderType === 10) {
                // 微课 取消订单接口
                cancelOrder = this.$api.microCourseCannelOrder
            } else if (v.orderType === 11) {
                // 模拟机 取消订单接口
                cancelOrder = this.$api.simulationCancelOrder
            } else if (v.orderType === 12) {
                // 计时卡 取消订单接口
                cancelOrder = this.$api.timeAppPayCancel
            } else if (v.orderType === 13) {
                // 福利商城 取消订单接口
                cancelOrder = this.$api.cancelWelfareOrder
            } else if (v.orderType === 14) {
                // 科二考场讲解 取消订单接口
                cancelOrder = this.$api.vipGoodsCannelOrder
            } else if (v.orderType === 15) {
                // 港安排班 排班 取消
                cancelOrder = this.$api.ganganBookingCancelOrder
            } else if (v.orderType === 16) {
                // 港安排班余额 取消
                cancelOrder = this.$api.gangAnPlanOrderCancel
            }
            this.dialogData = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.dialogData.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.dialogData.visible = false
                    cancelOrder({ orderId: v.id, id: v.id, orderType: v.orderType, goodsCode: v.goodsCode }).then(res => {
                        if (res.status) {
                            this.getList(1)
                        }
                        this.loading = false
                    })
                },
                title: '提示',
                content: '是否确认取消该订单？'
            }
        },
        // 拨打客服电话
        call (v) {
            v && this.$jsBridge.callBackHandler('callPhone', { tel: v })
        },
        // 点击输入框事件
        clickInput () {
            this.$refs.input.focus()
        },
        // 申请退款
        resetRefund (v) {
            this.dialogData = {
                visible: true,
                rightBtnName: '确定',
                leftBtnName: '取消',
                leftBtnMethod: () => {
                    this.dialogData.visible = false
                },
                rightBtnMethod: () => {
                    this.loading = true
                    this.dialogData.visible = false
                    this.$api.revertRefundApplypeijia({ orderId: v.id }).then(res => {
                        if (res.status) {
                            this.getList(1)
                        }
                    })
                },
                title: '提示',
                content: '是否撤销退款申请？'
            }
        },
        // 支付
        pay (v) {
            // 设置城市code
            let cityCode = this.$jsBridge.callBackHandler('passRegionCodeData')

            if (v.orderType === 6) {
                if (Number(v.paymentType) === 5) {
                    this.codeDialogData = {
                        visible: true,
                        rightBtnName: '立即激活',
                        leftBtnName: '取消',
                        leftBtnMethod: () => {
                            this.codeDialogData.visible = false
                        },
                        rightBtnMethod: () => {
                            if (this.codeValue === '') {
                                Toast('激活码不能为空')
                                return
                            }
                            this.loading = true
                            this.$api.activePeijia({ activeCode: this.codeValue, orderId: v.id }).then(res => {
                                this.loading = false
                                if (res.code === '200' && res.status) {
                                    this.codeDialogData.visible = false
                                    Toast.success('激活成功')
                                    setTimeout(() => {
                                        this.$router.replace(`/peijia/orderDetail?id=${v.id}&headShow=${this.$route.query.headShow}`)
                                    }, 1000)
                                } else if (res.result) {
                                    Toast(res.result)
                                } else {
                                    Toast(res.message)
                                }
                            })
                        },
                        title: '输入6位激活码',
                        content: ''
                    }
                } else {
                    this.$router.push({
                        name: 'pay',
                        query: {
                            payId: v.id,
                            money: v.orderPrice,
                            type: '6',
                            headShow: this.$route.query.headShow
                        }
                    })
                }
                return
            }
            if (v.orderType === 10) {
                let apiName = v.goodsCode >= 100 && v.goodsCode <= 299 ? this.$api.vipGoodsCheckPayOpen : this.$api.checkMicroCoursePayOpen

                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                apiName({ orderId: v.id, goodsCode: v.goodsCode }).then(res => {
                    if (res.status && res.code === '200') {
                        this.$api.getMicroCourseOrderDetails({ orderId: v.id }).then(resC => {
                            Toast.clear()
                            // 暴露支付回调方法
                            this.$jsBridge.registerHandler('payCallback', (v) => {
                                this.$router.push({ name: 'payResult',
                                    query: {
                                        result: v,
                                        flag: '1',
                                        headShow: this.$route.query.headShow,
                                        type: '10',
                                        id: v.id,
                                        goodsCode: v.goodsCode,
                                        source: this.$route.query.source,
                                        courseId: resC.result.courseId } })
                            })
                            // 判断是否IOS && 苹果支付
                            if (this.IOS) {
                                this.$jsBridge.callBackHandler('setApplePayType', { payType: 7 })
                                this.$jsBridge.callBackHandler('applyPay', { orderId: v.id, productId: resC.result.productId, goodsCode: v.goodsCode || '' })
                            } else {
                                this.$router.push({
                                    name: 'pay',
                                    query: {
                                        payId: v.id,
                                        money: v.orderPrice,
                                        goodsCode: v.goodsCode,
                                        type: '10',
                                        headShow: this.$route.query.headShow,
                                        source: this.$route.query.source,
                                        courseId: resC.result.courseId
                                    }
                                })
                            }
                        })
                    } else if (res.code === '801' || res.code === '30005') {
                        Toast(res.message)
                        this.getList(1)
                    } else if (res.code === '30006') {
                        Toast.clear()
                        // 错误状态码处理
                        this.dialogData = {
                            visible: true,
                            rightBtnName: '查看我的课程',
                            leftBtnMethod: () => {
                                this.dialogData.visible = false
                            },
                            rightBtnMethod: () => {
                                this.dialogData.visible = false
                                this.$router.push({ name: 'microCourseMy' })
                            },
                            title: '温馨提示',
                            content: res.message
                        }
                    } else {
                        Toast(res.message)
                    }
                })
            } else if (v.orderType === 11) {
                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                this.$api.simulationPay({ id: v.id }).then(res => {
                    Toast.clear()
                    if (res.status && res.code === '200') {
                        // 暴露支付回调方法
                        this.$jsBridge.registerHandler('payCallback', () => {
                            this.getList(1)
                        })
                        this.$jsBridge.callBackHandler('payByStringCode', { paymentStringCode: JSON.stringify(res.result), payWay: 2 })
                    } else {
                        Toast(res.result.message)
                    }
                    this.payLoading = false
                })
            } else if (v.orderType === 12) {
                let apiName = v.goodsCode >= 100 && v.goodsCode <= 299 ? this.$api.vipGoodsCheckPayOpen : this.$api.timeAppPayCheckPayOpen

                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                apiName({ orderId: v.id, cityCode: cityCode, goodsCode: v.goodsCode }).then(res => {
                    Toast.clear()
                    if (res.status && res.code === '200') {
                        this.$router.push({
                            name: 'pay',
                            query: {
                                payId: v.id,
                                money: v.orderPrice,
                                goodsCode: v.goodsCode,
                                type: v.orderType,
                                headShow: this.$route.query.headShow
                            }
                        })
                    } else if (res.code === '801' || res.code === '30005') {
                        Toast(res.message)
                        this.getList(1)
                    } else {
                        Toast(res.message)
                    }
                    this.payLoading = false
                })
            } else if (v.orderType === 13) {
                let apiName = v.goodsCode >= 100 && v.goodsCode <= 299 ? this.$api.vipGoodsCheckPayOpen : this.$api.checkPayOpenWelfare

                Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
                apiName({ orderId: v.id, goodsCode: v.goodsCode }).then(res => {
                    Toast.clear()
                    if (res.status && res.code === '200') {
                        this.$router.push({
                            name: 'pay',
                            query: {
                                payId: v.id,
                                money: v.orderPrice,
                                goodsCode: v.goodsCode,
                                type: v.orderType,
                                headShow: this.$route.query.headShow
                            }
                        })
                    } else if (res.code === '801' || res.code === '30005') {
                        Toast(res.message)
                        this.getList(1)
                    } else {
                        Toast(res.message)
                    }
                    this.payLoading = false
                })
            } else if ([15, 16].includes(v.orderType)) {
                this.getStudyDriveDetail(v.id).then(res => {
                    const { paymentAmount, paymentMethod } = res
                    this.studyDriveToPay({
                        id: v.id,
                        paymentAmount,
                        paymentMethod
                    }).then(() => {
                        this.getList(1)
                    })
                })
            } else if (v.orderType !== 2) {
                let checkPayOpen = null

                if (v.orderType === 5) {
                    checkPayOpen = this.$api.checkPayOpenExamVideo
                } else if (v.orderType === 4) {
                    checkPayOpen = this.$api.checkPayOpenTeachVideo
                } else if (v.orderType === 8) {
                    checkPayOpen = this.$api.checkVipPackagePayOpen
                } else if (v.orderType === 9) {
                    checkPayOpen = this.$api.lightCheckPayOpen
                } else {
                    checkPayOpen = this.$api.checkPayOpen
                }
                if (v.goodsCode >= 100 && v.goodsCode <= 299) {
                    checkPayOpen = this.$api.vipGoodsCheckPayOpen
                }
                checkPayOpen({ orderId: v.id, subject: v.vipDto.subject, cityCode: cityCode, goodsCode: v.goodsCode }).then(res => {
                    if (res.status && res.code === '200') {
                        // 判断是否IOS && 苹果支付
                        if (this.IOS) {
                            // 教学视频
                            if (v.orderType === 4) {
                                this.$jsBridge.callBackHandler('setApplePayType', { payType: 1 })
                            }

                            // 考场视频
                            if (v.orderType === 5) {
                                this.$jsBridge.callBackHandler('setApplePayType', { payType: (Number(v.vipDto.subject) === 2 ? 2 : 3) })
                            }

                            // vip题库
                            if (v.orderType === 1) {
                                // app埋点
                                this.$jsBridge.callBackHandler('onEventObjectUM', {
                                    eventId: 'e_vip_pay',
                                    map: JSON.stringify({ subject: 3 })
                                })

                                this.$jsBridge.callBackHandler('setApplePayType', { payType: 4 })
                            }

                            // vip套餐
                            if (v.orderType === 8) {
                                // app埋点
                                this.$jsBridge.callBackHandler('onEventObjectUM', {
                                    eventId: 'e_vipp_pay',
                                    map: JSON.stringify({ subject: 3 })
                                })

                                this.$jsBridge.callBackHandler('setApplePayType', { payType: 5 })
                            }

                            // 灯光仿真商品支付
                            if (v.orderType === 9) {
                                // 灯光仿真 立即开通按钮埋点
                                this.$jsBridge.callBackHandler('onEventUM', { eventId: 'e_lights_button_open' })
                                this.$jsBridge.callBackHandler('setApplePayType', { payType: 6 })
                            }
                            this.$jsBridge.callBackHandler('applyPay', { orderId: v.id, productId: v.vipDto.productId, goodsCode: v.goodsCode || '' })
                        } else {
                            this.$router.push({
                                name: 'pay',
                                query: {
                                    payId: v.id,
                                    goodsCode: v.goodsCode,
                                    money: v.pointMallDto ? v.pointMallDto.unitRmbAmount : v.orderPrice,
                                    type: v.orderType,
                                    headShow: this.$route.query.headShow
                                }
                            })
                        }
                    } else if (res.code === '801') {
                        Toast.fail('订单金额已更新，请重新支付')
                        this.getList(1)
                    } else {
                        Toast.fail(res.message)
                    }
                })
            } else {
                this.$router.push({
                    name: 'pay',
                    query: {
                        payId: v.id,
                        money: v.orderPrice,
                        goodsCode: v.goodsCode,
                        type: v.orderType,
                        headShow: this.$route.query.headShow
                    }
                })
            }
        },
        // 跳转详情
        goDetail (v) {
            let appType = Number(this.$jsBridge.callBackHandler('getAppType'))
            if (v.orderType === 2) {
                this.$router.push({
                    name: 'goodsOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow, sourceType: appType === 100 ? '2' : '1' }
                })
            } else if (v.orderType === 4) {
                this.$router.push({
                    name: 'teachVideoOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 5) {
                if (v.vipDto.subject === 3) {
                    this.$router.push({
                        name: 'examThreeVideoOrderDetail',
                        query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                    })
                }
                if (v.vipDto.subject === 2) {
                    this.$router.push({
                        name: 'examTwoVideoOrderDetail',
                        query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                    })
                }
            } else if (v.orderType === 6) {
                this.$router.push({
                    name: 'peijiaOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 7) {
                this.$router.push({
                    name: 'ensureOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 8) {
                this.$router.push({
                    name: 'vipPackageOderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 9) { // 跳转到灯光仿真的订单详情页
                this.$router.push({
                    name: 'goodsLightOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 10) { // 跳转到微课的订单详情页
                this.$router.push({
                    name: 'microCourseOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 11) { // 跳转到模拟机的订单详情页
                this.$router.push({
                    name: 'simulationOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 12) { // 跳转到计时卡的订单详情页
                this.$router.push({
                    name: 'timeAppPayOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 13) { // 跳转到微课订单详情页
                this.$router.push({
                    name: 'welfareOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if (v.orderType === 14) { // 跳转到vip商品订单详情页
                this.$router.push({
                    name: 'vipGoodsOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            } else if ([15, 16].includes(v.orderType)) { // 跳转到vip商品订单详情页
                this.$router.push({
                    name: 'studyDriveOrder',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow, orderType: v.orderType }
                })
            } else {
                this.$router.push({
                    name: 'vipOrderDetail',
                    query: { id: v.id, goodsCode: v.goodsCode, headShow: this.$route.query.headShow }
                })
            }
        },
        // 获取数据
        getList (refresh) {
            if (refresh) {
                this.pageData.current = 1
            }
            const postData = Object.assign({ orderStatus: this.active ? this.active : '' }, this.pageData)
            this.payLoading = true
            this.$api.getOrderList(postData).then(res => {
                setTimeout(() => {
                    this.payLoading = false
                    Toast.clear()
                }, 500)
                if (this.pageData.current === 1) {
                    this.$nextTick(() => {
                        window.scrollTo(0, 0)
                        window.scrollTo(0, 1)
                    })
                }
                this.error = false
                if (res.status) {
                    if (refresh) {
                        this.orderList = res.result.records.map(item => {
                            item.orderTime = this.moment.formatTime(item.orderTime, 'YYYY-MM-DD HH:mm:ss')
                            return item
                        })
                    } else {
                        res.result.records.map(item => {
                            item.orderTime = this.moment.formatTime(item.orderTime, 'YYYY-MM-DD HH:mm:ss')
                            this.orderList.push(item)
                        })
                    }
                    this.pageData.current++
                    this.finished = res.result.records.length < this.pageData.size // 首次加载的数据不能铺满屏幕， 设置加载完毕状态， 不再触发load
                } else {
                    this.error = true
                }
                this.refreshLoading = false
                this.loading = false
            })
        }
    }
}
</script>

<style scoped lang="scss">
.order-card-wrapper{
    .van-list {
        min-height: 90vh;
        background: #FAFAFA;
    }

    .payment { // 待付款
        color: #53CB85;
    }

    .beshipped { // 待发货
        color: #FF5050;
    }

    .shipped { // 已发货
        color: #999999;
    }

    .completed { // 已完成
        color: #999999;
    }

    .refund { // 退款中
        color: #999999;
    }

    .cancelled { // 已取消
        color: #999999;
    }

    .time-type {
        margin-top: 10px;
    }

    .card {
        background-color: white;
        box-sizing: border-box;
        padding: 20px 15px 15px;
        margin-bottom: 10px;

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title-info {
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                line-height: 14px;

                p {
                    padding: 4px;
                }
            }

            .status {
                font-size: 15px;
                font-weight: 400;
            }
        }

        .middle {
            border-top: 1px solid #eeeeee;
            margin-top: 20px;
            padding: 14px 0 10px;

            &.border-none {
                border-bottom: none;
            }

            .goods-info {
                margin-top: 7px;
                display: flex;

                .img-wrapper {
                    line-height: 1;
                    font-size: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    overflow: hidden;
                }

                .img {
                    width: 100px;
                    height: 100px;
                }

                .right-box {
                    display: flex;
                    flex: 1;
                    box-sizing: border-box;
                    padding: 0 0 0 15px;
                    flex-direction: column;
                    justify-content: center;

                    .goods-name {
                        font-size: 15px;
                        font-weight: 600;
                        color: #333333;
                        word-wrap: break-word;
                    }

                    .goods-exam-place-name {
                        color: #333333;
                        margin-top: 8px;
                        font-size: 14px;
                        line-height: 1;
                    }

                    .other-name {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 5px 0 0 0;
                        box-sizing: border-box;
                        padding: 0 5px;
                        width: fit-content;
                        height: 20px;
                        border-radius: 3px;
                        border: 1px solid #666666;
                        font: 400 14px PingFangSC-Regular, PingFang SC;
                        color: #666666;
                    }

                    .price {
                        line-height: 1;
                        display: flex;
                        justify-content: space-between;
                        padding-top: 10px;
                        font-size: 14px;
                        color: #666666;
                    }
                    .remark{
                        margin: 8px 0 0 0;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                    }
                }
            }

            .summation {
                padding-top: 10px;
                text-align: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
            }

            .summation span:nth-child(n+2) {
                color: red;
            }
        }

        .footer {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            width: 100%;
            padding: 15px 0;
            border-top: 1px solid #eeeeee;
            box-sizing: border-box;

            .button {
                width: 90px;
                height: 24px;
                margin: 2px;
                line-height: 24px;
                font-size: 12px;
                border-radius: 3px;
                border: 1px solid rgba(204, 204, 204, 1);
            }
        }
    }
}
.teacher-info {
    margin: 15px 0 0 0;

    p {
        word-break: break-all;
        padding: 0 4px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
    }

    .exist b {
        font-weight: 400;
        color: #54CB85;
    }
}

.password-input {
    position: relative;
    margin-top: 20px;

    input {
        opacity: 0;
        height: 100px;
        width: 100px;
        border: none;
        position: absolute;
        left: -100%;
    }

    ul {
        justify-content: center;
        display: flex;
        align-items: center;
        text-align: center;

        li {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            border: 1px solid #cccccc;
            color: #333333;

            & + li {
                border-left: none;
            }
        }
    }
}

.none-order {
    text-align: center;
    min-height: calc(100vh - 104px);

    img {
        margin-top: 150px;
        width: 150px;
        margin-bottom: 38px;
    }

    p {
        font-size: 18px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
    }
}
</style>
